const PRODUCTION_CUSTOM_AUTH_HOST = 'app.precepi.com';

/**
 * Firebase redirect sign-in must use the same helper origin as the page that
 * starts the flow. Production Hosting serves one build from both the default
 * web.app hostname and the app.precepi.com custom domain, so a single static
 * Vite value cannot be correct for both origins.
 */
export function resolveFirebaseAuthDomain(
  configuredAuthDomain: string,
  runtimeHostname?: string,
): string {
  const hostname = runtimeHostname?.trim().toLowerCase();
  return hostname === PRODUCTION_CUSTOM_AUTH_HOST
    ? PRODUCTION_CUSTOM_AUTH_HOST
    : configuredAuthDomain;
}
